export interface Capabilities {
  readonly webgl2: boolean;
  readonly floatRenderTarget: boolean;
}

export function checkCapabilities(): Capabilities {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2');

  if (!gl) {
    return { webgl2: false, floatRenderTarget: false };
  }

  const floatRenderTarget = !!gl.getExtension('EXT_color_buffer_float');

  return { webgl2: true, floatRenderTarget };
}

export function getMissingCapabilities(caps: Capabilities): readonly string[] {
  const missing: string[] = [];
  if (!caps.webgl2) {
    missing.push('WebGL 2.0');
  }
  if (!caps.floatRenderTarget) {
    missing.push('EXT_color_buffer_float');
  }
  return missing;
}
